module.exports = __webpack_public_path__ + "img/04-kiosk-devices.c48337ec.png";